/*
  Authenticated
  Root component to those that require authentication to access
*/

import { Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

// Component Defintion
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-authenticated',
  styleUrls: ['./authenticated.component.scss'],
  templateUrl: './authenticated.component.html'
})
export class AuthenticatedComponent implements OnInit {
  constructor(el: ElementRef, private router: Router, private titleService: Title) {
    el.nativeElement.classList.add('flex-cell-full-height');
  }

  ngOnInit() {
    this.titleService.setTitle('Flow');
  }
}
